// @flow
import type {
  Store,
  Reducer,
  Dispatch,
} from 'redux'

import { applyMiddleware, compose, createStore } from 'redux'

// Middleware
import createSagaMiddleware from 'redux-saga'
import ignoreStoreMiddleware from './middleware/ignoreStore'

const sagaMiddleware = createSagaMiddleware()

// Local Types
export type FinalStore<S, A: { type: $Subtype<string> }> = {
  dispatch: Dispatch<A>,
  getState(): S,
  subscribe(listener: () => void): () => void,
  replaceReducer(nextReducer: Reducer<S, A>): void,
  asyncReducers: Object,
  runSaga: (saga: () => Generator<*, *, *>) => any,
}

type CreateStoreArgs<S, A: { type: $Subtype<string> }> = {
  middleware?: Array<Function>,
  ignoreStore?: boolean,
  preloadedState: S,
  reducer: Reducer<S, A>,
}

export default function composeStore<S, A: { type: $Subtype<string> }> ({
  middleware = [],
  ignoreStore = true,
  preloadedState,
  reducer,
  }: CreateStoreArgs<S, A>): FinalStore<S, A> {
  //
  const finalMiddleware = compose(
    applyMiddleware(...middleware, sagaMiddleware, ignoreStoreMiddleware),
  )

  const store: Store<S, A> = createStore(reducer, preloadedState, finalMiddleware)

  const finalStore: FinalStore<S, A> = {
    ...store,
    asyncReducers: {},
    runSaga: sagaMiddleware.run,
  }

  return finalStore
}
